import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './Loading.css';
const cx = classNames.bind(styles);

const Loading = ({ content, noInverted, size, active, ...rest }) => (
  <Dimmer active={typeof active === 'undefined' ? true : active} inverted={!!noInverted ? false : true}>
    <Loader
      active={typeof active === 'undefined' ? true : active}
      inverted
      size={size || 'medium'}
      content={typeof content === 'undefined' ? 'Loading' : content}
      {...rest}
    />
  </Dimmer>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/script/components/common/Loading.js